import { constants } from 'lib_ui-services';

export default {
    verb: 'didCreate',
    namespace: 'application',
    relation: 'savedFilter',
    description: 'close Saved Filter name dialog',
    logic: closeDialog
};

function closeDialog({ data, dispatch }) {
    const { newRecord } = data || {};
    dispatch(
        {
            message: `Filter "${newRecord?.title || ''}" saved.`,
            addToList: false,
            isError: false, //todo: gl2025 remove
            variant: 'success',
            type: constants.notificationTypes.TOAST
        },
        {
            verb: 'pop',
            namespace: 'application',
            relation: 'notification'
        }
    );
    dispatch(
        {},
        {
            verb: 'close',
            namespace: 'application',
            relation: 'savedFilter',
            type: 'ignore-changes'
        }
    );
}
